export const GET_DEEP_LINK = 'GET_DEEP_LINK';
export const GET_DEEP_LINK_REQUEST = 'GET_DEEP_LINK_REQUEST';
export const GET_DEEP_LINK_SUCCESS = 'GET_DEEP_LINK_SUCCESS';
export const GET_DEEP_LINK_ERROR = 'GET_DEEP_LINK_ERROR';
